(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ac-client-experience"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ac-client-experience')) {
  customElements.define('ac-client-experience', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ac-experience__track');
      this.cards = Array.from(this.querySelectorAll('.ac-experience__card'));
      if (!this.track || !this.cards.length) return;
      this.abort = new AbortController();
      const opts = { signal: this.abort.signal };
      this.index = this.cards.length >= 3 ? 1 : 0;
      this.classList.add('is-ready');
      this.querySelectorAll('.ac-experience__arrow').forEach(button => {
        button.hidden = this.cards.length < 2;
        button.addEventListener('click', () => this.go(this.index + (button.classList.contains('ac-experience__arrow--next') ? 1 : -1)), opts);
      });
      this.track.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        this.go(event.key === 'Home' ? 0 : event.key === 'End' ? this.cards.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }, opts);
      this.track.addEventListener('scroll', () => {
        // On desktop, navigation selects a review while all three cards stay visible.
        if (matchMedia('(min-width: 768px)').matches) return;
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          const rect = this.track.getBoundingClientRect();
          const middle = rect.left + rect.width / 2;
          let nearest = 0, distance = Infinity;
          this.cards.forEach((card, i) => {
            const r = card.getBoundingClientRect();
            const delta = Math.abs(r.left + r.width / 2 - middle);
            if (delta < distance) { nearest = i; distance = delta; }
          });
          if (nearest !== this.index) this.activate(nearest);
        });
      }, opts);
      this.cards.forEach((card, i) => card.querySelector('.ac-experience__photo').addEventListener('click', () => this.go(i), opts));
      this.addEventListener('shopify:block:select', event => {
        const i = this.cards.findIndex(card => card.dataset.blockId === event.detail.blockId);
        if (i >= 0) this.go(i, false);
      }, opts);
      this.resize = new ResizeObserver(() => this.go(this.index, false));
      this.resize.observe(this.track);
      this.go(this.index, false);
    }
    activate(i) {
      this.index = i;
      this.cards.forEach((card, n) => card.classList.toggle('is-current', n === i));
      const review = this.cards[i].querySelector('.ac-experience__review');
      const detail = this.querySelector('.ac-experience__detail');
      if (review) detail.replaceChildren(review.cloneNode(true));
      else detail.replaceChildren();
      this.querySelector('.ac-experience__position').textContent = this.cards.length > 1 ? `${i + 1} / ${this.cards.length}` : '';
    }
    go(i, animate = true) {
      i = (i + this.cards.length) % this.cards.length;
      this.activate(i);
      const track = this.track.getBoundingClientRect(), card = this.cards[i].getBoundingClientRect();
      this.track.scrollTo({ left: this.track.scrollLeft + card.left + card.width / 2 - track.left - track.width / 2, behavior: animate && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto' });
    }
    disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); cancelAnimationFrame(this.frame); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
